import { render, staticRenderFns } from "./BidDashboardChart.vue?vue&type=template&id=011b67ad&scoped=true"
import script from "./BidDashboardChart.vue?vue&type=script&lang=js"
export * from "./BidDashboardChart.vue?vue&type=script&lang=js"
import style0 from "./BidDashboardChart.vue?vue&type=style&index=0&id=011b67ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011b67ad",
  null
  
)

export default component.exports